var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useEffect, useState } from 'react';
import { COMPONENT_MAP } from '../constants/COMPONENT_MAP';
import { TableComponent } from '../shared/TableComponent/TableComponent';
import { useGetProductListByAPIQuery } from '../../services/ProductSearchService';
import { ApplicationContext } from '../ApplicationProvider';
import { useLocation, useNavigate } from 'react-router';
import { ConfigitProductContext } from '../ConfigitProductProvider';
import { Link } from 'react-router-dom';
import { TextOnlyComponent } from '../shared/TextOnlyComponent/TextOnlyComponent';
import { Typography } from '@mui/material';
import theme from '../../theme';
import { Dialog } from '../shared/DialogComponent/Dialog';
import { ErrorModalComponent } from '../shared/ErrorModalComponent/ErrorModalComponent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ProductList = function (_ref) {
    var _data$product_api_lis;
    var count = _ref.count;
    var _a = useContext(ConfigitProductContext), initialSearchCriteria = _a.initialSearchCriteria, apuCount = _a.apuCount;
    var iniSearchCriteria = initialSearchCriteria;
    count = apuCount;
    useEffect(function () { iniSearchCriteria = initialSearchCriteria; setItemOffset(0); }, [initialSearchCriteria]);
    var navigate = useNavigate();
    var location = useLocation();
    var urlParams = new URLSearchParams(location.search);
    var _b = useState(COMPONENT_MAP.ProductList.colHeads), columnHeaders = _b[0], setColumnHeaders = _b[1];
    var _c = useContext(ApplicationContext), itemOffset = _c.itemOffset, itemsPerPage = _c.itemsPerPage, setItemOffset = _c.setItemOffset, setItemsPerPage = _c.setItemsPerPage, setDialog = _c.setDialog, setShowDialog = _c.setShowDialog;
    var _d = useState('TradeName'), fieldSort = _d[0], setFieldSort = _d[1];
    var _e = useState('Product Trade Name'), sortingField = _e[0], setSortingField = _e[1];
    var _f = useState(0), sortDirection = _f[0], setSortDirection = _f[1];
    var _g = useGetProductListByAPIQuery(iniSearchCriteria, itemOffset, itemsPerPage, fieldSort, sortDirection, Number(iniSearchCriteria.approvedUseId), Number(iniSearchCriteria.categoryId), undefined), data = _g.data, loading = _g.loading, error = _g.error;
    var queryParams = new URLSearchParams(location.search);
    useEffect(function () { if (error) {
        setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "An Error Occurred", children: /*#__PURE__*/ _jsx(ErrorModalComponent, {}) }));
        setShowDialog(true);
    } }, [error]);
    var navigateToDetail = function (componentId, e) { if (e && e.ctrlKey) {
        window.open("/productDetail/".concat(componentId, "?").concat(urlParams.toString()), "_blank");
    }
    else {
        navigate("/productDetail/".concat(componentId, "?").concat(urlParams.toString()));
    } };
    var handlePageSizeChange = function (event) {
        var newPageSize = parseInt(event.target.value);
        setItemsPerPage(newPageSize);
        setItemOffset(itemOffset); // Reset to be the first page
    }; // Invoke when user click to request another page.
    var handlePageClick = function (event) { return __awaiter(void 0, void 0, void 0, function () { var newOffset; return __generator(this, function (_a) {
        if (!count)
            return [2 /*return*/];
        newOffset = event.selected * itemsPerPage % count;
        setItemOffset(newOffset);
        return [2 /*return*/];
    }); }); };
    var handleSort = function (field) { var headers = __spreadArray([], COMPONENT_MAP.ProductList.colHeads, true); var newSortDir; if (sortingField === field) {
        newSortDir = sortDirection === 0 ? 1 : 0;
        for (var i = 0; i < headers.length; i++) {
            if (headers[i].className !== 'notvisible') {
                if (headers[i].name === field) {
                    headers[i].className = newSortDir === 0 ? 'th-inner sortable both sorted asc' : 'th-inner sortable both sorted desc';
                }
                else {
                    headers[i].className = 'th-inner sortable both unsorted';
                    setSortDirection(1);
                }
            }
        }
    }
    else {
        newSortDir = 0;
        for (var i = 0; i < headers.length; i++) {
            if (headers[i].className !== 'notvisible') {
                if (headers[i].name === field) {
                    headers[i].className = 'th-inner sortable both sorted asc';
                }
                else {
                    headers[i].className = 'th-inner sortable both unsorted';
                }
            }
        }
    } var sortColumn; switch (field) {
        case 'Product Trade Name':
            sortColumn = 'TradeName';
            break;
        case 'Company Name':
            sortColumn = 'ManufacturerName';
            break;
        case 'Approved Use':
            sortColumn = 'ApprovedUseCode';
            break;
        case 'CountryCode':
            sortColumn = 'CountryCode';
            break;
        default: sortColumn = 'TradeName';
    } setSortDirection(newSortDir); setSortingField(field); setFieldSort(sortColumn); setColumnHeaders(headers); };
    var handleBackClick = function () { history.back(); };
    return /*#__PURE__*/ _jsxs("div", { id: "roofnav_results", className: "p-3", children: [/*#__PURE__*/ _jsxs("div", { className: "p-5", children: [/*#__PURE__*/ _jsx("div", { className: "col px-4 my-1 text-right", children: /*#__PURE__*/ _jsx(Link, { onClick: handleBackClick, to: '#', children: /*#__PURE__*/ _jsx(TextOnlyComponent, { buttonText: 'Back', iconName: 'arrow_left' }) }) }), Object.keys(initialSearchCriteria).length > 0 ? /*#__PURE__*/ _jsx(TableComponent, { loading: loading, count: count, offset: itemOffset, limit: itemsPerPage, handlePageSizeChange: handlePageSizeChange, handlePageClick: handlePageClick, handleSort: handleSort, colHeads: columnHeaders, navigateToDetail: navigateToDetail, rows: data && ((_data$product_api_lis = data.product_api_listing) === null || _data$product_api_lis === void 0 ? void 0 : _data$product_api_lis.map(function (productlist) { var row = []; row.push(productlist === null || productlist === void 0 ? void 0 : productlist.ComponentId.toString()); row.push(productlist === null || productlist === void 0 ? void 0 : productlist.TradeName); row.push(productlist === null || productlist === void 0 ? void 0 : productlist.ManufacturerName); row.push(productlist === null || productlist === void 0 ? void 0 : productlist.ApprovedUseCode); row.push(productlist === null || productlist === void 0 ? void 0 : productlist.CountryCode); return row; })) }) : /*#__PURE__*/ _jsx(Typography, { className: "headline-1 justify-content-center d-flex", color: theme.palette.rnSteel.steel700, children: "No seach criteria received, please return and search again" })] }), /*#__PURE__*/ _jsx("div", { className: "clearfix" })] });
};
